import { useEffect } from "react";
import { useTenantBrand } from "@/hooks";
import { PLATFORM_SITE_NAME, resolveCssVariableToHex } from "@/utils";

const OG_TITLE_SELECTOR = 'meta[property="og:title"]';
const THEME_COLOR_SELECTOR = 'meta[name="theme-color"]';
const NAVBAR_THEME_CSS_VAR = "--secondary-dark";

const resolveFaviconType = (href: string): string =>
  href.endsWith(".webp") ? "image/webp" : "image/svg+xml";

/**
 * Syncs document title, favicon, og:title and theme-color with tenant branding.
 */
export const TenantDocumentMeta = (): null => {
  const { siteName, faviconSrc } = useTenantBrand();

  useEffect(() => {
    document.title = siteName;

    const faviconLink = document.querySelector<HTMLLinkElement>("link[rel='icon']");

    if (faviconLink) {
      faviconLink.href = faviconSrc;
      faviconLink.type = resolveFaviconType(faviconSrc);
    }

    const ogTitleMeta = document.querySelector<HTMLMetaElement>(OG_TITLE_SELECTOR);

    if (ogTitleMeta) {
      ogTitleMeta.content = siteName;
    }

    const themeColorHex = resolveCssVariableToHex(NAVBAR_THEME_CSS_VAR);
    const themeColorMeta =
      document.querySelector<HTMLMetaElement>(THEME_COLOR_SELECTOR);

    if (themeColorMeta && themeColorHex) {
      themeColorMeta.content = themeColorHex;
    }
  }, [faviconSrc, siteName]);

  useEffect(() => {
    return () => {
      document.title = PLATFORM_SITE_NAME;
    };
  }, []);

  return null;
};
